import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon } from '@livable/saas-react-components';
import { Button, Menu } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'src/stores';
import useStyles from './styles';
const ActionsCell = observer(_ref => {
  let handleModalClose = _ref.handleModalClose,
    params = _ref.params,
    property = _ref.property;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const currentCompany = store.homeDashboardStore.getCurrentCompany || {};
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  const open = Boolean(anchorEl);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    size: "small",
    className: classes.todoDropdown,
    id: "action-menu-trigger",
    "aria-controls": "action-menu",
    "aria-haspopup": "true",
    "aria-expanded": open ? 'true' : undefined,
    "aria-label": "resident menu",
    onClick: handleClick,
    state: open ? 'active' : undefined,
    'custom-attribute': '06-attach-file'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "dotdotdot"
  })), /*#__PURE__*/React.createElement(Menu, {
    type: "action-menu",
    id: "action-menu",
    MenuListProps: {
      'aria-labelledby': 'action-menu-trigger'
    },
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    elevation: 0,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    className: classes.lightTrigger,
    disabled: params.row.fileId === null,
    onClick: () => {
      property.allocations.setTempFileData('fileId', params.row.fileId);
      property.allocations.setTempFileData('isDeleted', false);
      property.allocations.setTempFileData('isReducted', false);
      currentCompany.billingTab.setIsFileChosen(true);
      handleModalClose();
    },
    variant: "menuAction",
    'custom-attribute': '01-attach-file'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "file-add"
  }), t('allocations.attach_file'))));
});
export default ActionsCell;